// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"24dc95d6","213":"694b7689","239":"74a971d6","455":"7668d5ed"}[chunkId] + ".chunk.js";
};